var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTikTokIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9692 13.12C25.2196 13.1259 22.5378 12.2666 20.3026 10.6635V21.8396C20.302 23.9095 19.6701 25.9298 18.4916 27.6304C17.313 29.331 15.6439 30.6308 13.7076 31.3559C11.7712 32.081 9.65983 32.1969 7.65589 31.6881C5.65194 31.1793 3.85094 30.07 2.49374 28.5086C1.13655 26.9472 0.287866 25.0082 0.0612041 22.9508C-0.165458 20.8934 0.240705 18.8158 1.22537 16.9958C2.21004 15.1757 3.72627 13.7001 5.57127 12.7662C7.41628 11.8324 9.50209 11.4848 11.5498 11.7699V17.3892C10.6135 17.0941 9.60798 17.1027 8.67687 17.4139C7.74576 17.725 6.93664 18.3227 6.36504 19.1217C5.79344 19.9207 5.48859 20.88 5.49402 21.8628C5.49944 22.8455 5.81487 23.8015 6.39525 24.594C6.97564 25.3866 7.79131 25.9754 8.7258 26.2762C9.66028 26.577 10.6658 26.5745 11.5988 26.269C12.5318 25.9636 13.3445 25.3708 13.921 24.5754C14.4974 23.7799 14.8081 22.8224 14.8087 21.8396V0H20.3026C20.2995 0.465211 20.3392 0.929719 20.4212 1.38764C20.6123 2.40836 21.0092 3.37936 21.5878 4.24129C22.1664 5.10321 22.9145 5.83796 23.7863 6.40063C25.0272 7.22124 26.4819 7.65817 27.9692 7.657V13.12Z",
    fill: "#7C6CC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTikTokIcon);
export default __webpack_public_path__ + "static/media/TikTokIcon.3a61ad0bc8f5434a643fefde681dca8d.svg";
export { ForwardRef as ReactComponent };